import {
  COMPROMISOS_LOADING,
  COMPROMISOS_HAS_ERRORED,
  SET_DATA_COMPROMISO,
  LIMPIAR_DATOS_COMPROMISOS,
  SET_BROKERS,
  SET_DATOS_NUEVO_COMPROMISO,
  LIMPIAR_NUEVO_COMPROMISO,
  GUARDAR_COMPROMISO_ERROR,
  GUARDAR_COMPROMISO_LOADING,
  CONSULTAR_CLIENTE_ERROR,
  CONSULTAR_CLIENTE_LOADING
} from "./aCompromisos";

const initialState = {
  compromisos: [],
  brokers: [],

  isLoading: false,//carga de compromisos
  error: null,

  consultarClienteIsLoading: false,
  consultarClienteError: null,

  guardarCompromiso: false,
  errorCompromiso: null,

  nuevoCompromiso: {
    idCompromiso: null,
    
    brokerSolicitante: null,
    emailAsesor: "",
    tipoIdentificacion: null,
    numeroIdentificacion: "",
    nombreCompleto: "",
    emailCliente: "",
    telefono: "",
    celular: "",
    sucursal:null,

    clienteEncontrado: false,
    origenCliente: "MANUAL",

    stupendo: false,
    dataTitular: [],

    lineasNegocio: [],
    polizasVigentes:[],

    giroNegocio: null,
    actividadEconomica: null,
    cuentaSeguro: false,
    brokerActual: null,
    aseguradoraActual: null,
    fechaVencimiento: "",

    instrucciones : "",

    pasoActual: 1
  }
};

const reducerCompromisos = (state = initialState, action) => {
  switch (action.type) {
    case COMPROMISOS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };

    case COMPROMISOS_HAS_ERRORED:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };

    case SET_DATA_COMPROMISO:
      return {
        ...state,
        compromisos: action.payload,
        isLoading: false,
        error: null
      };
    case LIMPIAR_DATOS_COMPROMISOS:
      return {
        ...state,
        compromisos: [],
        brokers: [],
        error: null,
        compromisoSeleccionado: null
      };

    case SET_BROKERS:
      return {
        ...state,
        brokers: action.payload
      };

    case SET_DATOS_NUEVO_COMPROMISO:
      return {
        ...state,
        nuevoCompromiso: {
          ...state.nuevoCompromiso,
          ...action.payload
        }
      };

    case LIMPIAR_NUEVO_COMPROMISO:
      return {
       ...state,
        nuevoCompromiso: {
            ...initialState.nuevoCompromiso
        }
      };

    case GUARDAR_COMPROMISO_LOADING:
      return {
        ...state,
        guardarCompromiso: action.payload
      };

    case GUARDAR_COMPROMISO_ERROR:
      return {
        ...state,
        errorCompromiso: action.payload
      };

    case CONSULTAR_CLIENTE_LOADING:
      return {
        ...state,
        consultarClienteIsLoading: action.payload
      };

    case CONSULTAR_CLIENTE_ERROR:
      return {
        ...state,
        consultarClienteError: action.payload
      };

    default:
      return state;
  }
};

export default reducerCompromisos;